///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {


    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportDistributor = Meevo.Plugins.Reports.IReportDistributor;
    import IReportPurchaseOrder = Meevo.Plugins.Reports.IReportPurchaseOrder;

    export class PurchaseOrderToDistributorStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<IReportDistributor>, public child: ICollectionBase<IReportPurchaseOrder>) {
        }

        populate(): void {
            let noDistributorCategory = <ISmartMoverCategoryModel<IReportDistributor>>this.parent.models.filter((row) => row.id === Guid.empty.toString())[0];

            if (!noDistributorCategory) {
                noDistributorCategory = new CollectionCategory({
                    id: Guid.empty.toString(),
                    displayName: 'LABEL_NO_DISTRIBUTOR',
                    objectState: ObjectStateEnum.Active
                }, {idKey: 'id', displayNameKey: 'displayName', collection: this.parent} as IModelOptions<any>);
                this.parent.models.push(noDistributorCategory);
            }

            this.parent.models.forEach((category: ISmartMoverCategoryModel<IReportDistributor>) => {
                category.resetModels([]);
            });

            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<IReportDistributor>>category).resetModels(
                    this.child.models.filter((model) => model.get('distributorId') === category.id)
                );
            }

            noDistributorCategory.resetModels(
                this.child.models.filter((model) => !model.get('distributorId'))
            );
        }
    }
}
